export default "__VITE_ASSET__XEh5HaVy__"